export const isDev = import.meta.env.DEV;
